<template>
  <div class="mpq" :class="{ 'mpq--sm': size === 'sm' }">
    <div class="mpq__qr">
      <img v-if="qrImg" :src="qrImg" class="mpq__img" alt="AI配音小狐狸 小程序码" />
      <div v-else class="mpq__placeholder">
        <canvas ref="canvas" class="mpq__canvas"></canvas>
        <img class="mpq__logo" src="/images/logo.png" alt="" />
      </div>
    </div>
    <div v-if="!bare" class="mpq__text">
      <div class="mpq__name">AI配音小狐狸 · 小程序</div>
      <div class="mpq__hint">手机微信扫码，打开即用</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import QRCode from 'qrcode'
import { SITE_CONFIG } from '@/config'

defineProps({
  // sm：紧凑横向（登录页）/ 默认竖版（页脚）
  size: { type: String, default: '' },
  // bare：只显示二维码本体（悬浮浮层等由外层自行配文字）
  bare: { type: Boolean, default: false }
})

const qrImg = SITE_CONFIG.miniProgramQr
const canvas = ref(null)

onMounted(() => {
  // 未配置真实小程序码时，用占位 scheme 渲染示意二维码
  if (!qrImg && canvas.value) {
    QRCode.toCanvas(canvas.value, SITE_CONFIG.miniProgramScheme, {
      width: 96,
      margin: 0,
      color: { dark: '#2e2117', light: '#ffffff' }
    }).catch(() => {})
  }
})
</script>

<style scoped>
/* 竖版（页脚默认） */
.mpq {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.mpq__qr {
  position: relative;
  width: 108px;
  height: 108px;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
}

.mpq__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.mpq__placeholder {
  position: relative;
  width: 100%;
  height: 100%;
}

.mpq__canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.mpq__logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #fff;
  padding: 2px;
  box-sizing: content-box;
}

.mpq__name {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-2);
}

.mpq__hint {
  font-size: 11px;
  color: var(--color-text-4);
}

/* 紧凑横向（登录页） */
.mpq--sm {
  flex-direction: row;
  gap: 14px;
  align-items: center;
}

.mpq--sm .mpq__qr {
  width: 84px;
  height: 84px;
  flex-shrink: 0;
}

.mpq--sm .mpq__text {
  text-align: left;
}

.mpq--sm .mpq__name {
  font-size: 13px;
  margin-bottom: 4px;
}
</style>
